import { createSelector } from "@reduxjs/toolkit";

import { getNextIdSelector } from "@skilitics/nautilus-core-designer-data";

import { applyDefinitionCreate, createNodeCreate, createPlaceholderCreate } from "../../nodes/creation/index.ts";
import { getManifestSelector, getPlaceholderManifestSelector } from "./appConfigSelectors.ts";
import { getNodeRoleSelector } from "./nodeRoleSelectors.ts";
import { getNodeTitleSelector } from "./nodeTitleSelectors.ts";

export const createNodeSelector = createSelector(
  [getManifestSelector, getPlaceholderManifestSelector, getNextIdSelector, getNodeTitleSelector, getNodeRoleSelector],
  (getManifest, getPlaceholderManifest, getNextId, getNodeTitle, getNodeRole) =>
    createNodeCreate({
      getManifest,
      getPlaceholderManifest,
      getNextId,
      getNodeTitle,
      getNodeRole,
    }),
);

export const createPlaceholderSelector = createSelector(
  [getPlaceholderManifestSelector, createNodeSelector],
  (getPlaceholderManifest, createNode) => createPlaceholderCreate(getPlaceholderManifest, createNode),
);

export const applyDefinitionSelector = createSelector(
  [createNodeSelector, getManifestSelector, getNodeTitleSelector],
  (createNode, getManifest, getNodeTitle) => applyDefinitionCreate(createNode, getManifest, getNodeTitle),
);
